import http from '@/http'
import createCrudModule from 'vuex-crud'
import { withDataFilter } from '@/store/index'

let parseError = res => res
let parseSingle = res => res

const store = createCrudModule({
  client: http,
  resource: 'admin/managers',
  urlRoot: 'admin/managers',

  state: {
    total: 0
  },

  parseList(response) {
    return Object.assign({}, response, {
      data: response.data.data,
      total: response.data.total
    })
  },

  onFetchListSuccess(state, response) {
    state.total = response.total
  },

  actions: {
    update({ commit }, { id, data, config } = {}) {
      commit('updateStart')
      return http
        .post(`admin/managers/${id}`, data, config)
        .then(res => {
          let parsedResponse = parseSingle(res)
          commit('updateSuccess', parsedResponse)
          return parsedResponse
        })
        .catch(err => {
          let parsedError = parseError(err)
          commit('updateError', parsedError)
          return Promise.reject(parsedError)
        })
    }
  }
})

export default withDataFilter(store)
